import * as React from 'react'
const ConversationsIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M9.53 3a7.51 7.51 0 00-6.8 10.67c-.25 1-.54 2.11-.72 2.84A1.25 1.25 0 003.51 18l2.93-.71A7.5 7.5 0 109.53 3zm-6 7.5a6 6 0 113.33 5.37l-.24-.12-.27.06-2.79.67c.2-.78.47-1.81.69-2.71l.07-.27-.13-.26a6 6 0 01-.66-2.74z" className="-secondary-color" fill="#d7dae0"/>
      <path d="M14.53 21a7.48 7.48 0 01-5.1-2h.1a8.35 8.35 0 002.08-.26 6 6 0 005.59.13l.24-.12.27.06c.92.22 2 .45 2.74.61-.18-.75-.42-1.75-.64-2.65l-.07-.27.13-.26a6 6 0 00-2.09-7.78A8.48 8.48 0 0017 6.41a7.51 7.51 0 014.35 10.26c.25 1 .51 2.1.67 2.81A1.24 1.24 0 0120.53 21c-.73-.15-1.87-.39-2.91-.64a7.42 7.42 0 01-3.09.64z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default ConversationsIcon